<template>
  <div>
    <!-- Alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <!-- Tabla de categorias -->
     <template v-if="skeletonLoader">
       <v-skeleton-loader
         type="table-heading, table-thead, table-tbody@2, table-tfoot"
       >
       </v-skeleton-loader>
     </template>
     <template v-else>
    <v-row justify="center">
      <v-col cols="12">
        <v-card>
          <v-card-title class="text-h5 font-weight-bold primary--text">
            <v-row>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    color="primary"
                    class="mx-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="regresar"
                  >
                    <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>
                </template>
                <span>Regresar</span>
              </v-tooltip>

              <v-col cols="12" sm="10" md="7"> Saberes Registrados </v-col>

              <v-col cols="12" sm="10" md="3">
                <v-text-field
                  outlined
                  dense
                  append-icon="mdi-magnify"
                  label="Buscar Categoria"
                  hide-details
                  v-model="searchTable"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="2" md="1">
                <v-btn exact color="primary" @click="registrar">
                  Registrar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-data-table
            fixed-header
            height="calc(100vh - 220px)"
            class="elevation-2"
            :headers="headersTable"
            :items="saberes"
            :search="searchTable"
            :footer-props="{ 'items-per-page-options': [50, 100, -1]}"
          >
            <template v-slot:[`item.acciones`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click="detalle(item.categoria_id, item.id)"
                  >
                    mdi-eye
                  </v-icon>
                </template>
                <span>Detalles</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    class="ml-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="actualizar(item.categoria_id, item.id)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <span>Actualizar</span>
              </v-tooltip>
              <!-- <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="error"
                    class="ml-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="activarAlertaEliminar(item.id)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                <span>Eliminar</span>
              </v-tooltip> -->
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    </template>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="justify-center text-h5"
          >¿ Desea eliminar el saber ?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="closeDelete">Cancelar </v-btn>
          <v-btn text color="error" @click="eliminarSaber(saber_id_eliminar)"
            >OK
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Alert from "../../../components/admin/Alert.vue";
export default {
  data: () => ({
    alert: false,
    alertType: "",
    alertTitle: "",
    alertMessage: "",

    searchTable: null,
    skeletonLoader: true,

    form: true,
    loadingForm: false,

    dialogForm: false,
    editedIndex: -1,
    dialogDelete: false,
    saber_id_eliminar: null,

    saber: "",
    descripcion: "",

    saberReglas: [(v) => !!v || "Ingrese el saber"],

    headersTable: [
      {
        text: "Saber",
        value: "saber",
        align: "start",

        class: ["text-subtitle-1", "font-weight-black"],
      },
      {
        text: "Descripción",
        value: "descripcion",
        width: "600px",
        align: "start",

        class: ["text-subtitle-1", "font-weight-black"],
      },
      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
    ],
  }),

  computed: {
    saberes() {
      return this.$store.getters.obtenerSaberes;
    },
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  mounted() {
    this.$store.dispatch(
      "gestionarSaberesCampesena",
      this.$route.params.idCategoria
    );

    setTimeout(() => {
      this.skeletonLoader= false
    }, 1000);
  },
  components: {
    Alert,
  },
  methods: {
    open() {
      this.dialogForm = true;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    activarAlertaEliminar(id_saber) {
      this.saber_id_eliminar = id_saber;
      this.dialogDelete = true;
    },

    // eliminarSaber(id_saber) {
    //   this.$store
    //     .dispatch("eliminarSaberCampesena", {
    //       id_categoria: this.$route.params.id_categoria,
    //       id_saber: id_saber,
    //     })
    //     .then((response) => {
    //       if (response.status == "success") {
    //         this.alert = true;
    //         let message = response.message.split(",");
    //         this.alertType = "success--text";
    //         this.alertTitle = message[0];
    //         this.alertMessage = message[1];

    //         this.$store.dispatch(
    //           "gestionarSaberesCampesena",
    //           this.$route.params.id_categoria
    //         );

    //         setTimeout(() => {
    //           this.loadingTable = false;
    //           this.alert = false;
    //         }, 2000);
    //       } else {
    //         this.loadingForm = false;
    //         this.alertType = "error--text";
    //         this.alertTitle = "Error";
    //         for (const error in response.message) {
    //           this.alertMessage = response.message[error][0];
    //         }
    //         this.alert = true;

    //         setTimeout(() => {
    //           this.alert = false;
    //         }, 3000);
    //       }
    //       this.dialogDelete = false;
    //     })
    //     .catch(() => {});
    // },

    abrirDialog() {
      this.dialogForm = true;
    },
    registrar() {
      this.$router.push({
        name: "campesena-saber-resgistrar",
      });
    },

    detalle(categoria, saber) {
      this.$router.push({
        name: "campesena-saber-detalles",
        params: { idCategoria: categoria, idSaber: saber },
      });
    },
    actualizar(categoria, saber) {
      this.$router.push({
        name: "campesena-saber-actualizar",
        params: { idCategoria: categoria, idSaber: saber },
      });
    },
    cerrarDialog() {
      this.dialogForm = false;
      this.$refs.form.reset();
      this.editedIndex = -1;
    },

    regresar() {
      this.$router.back();
    },
  },
};
</script>
